module.exports = __webpack_public_path__ + "img/arrow_01_feature1_m.37fbc57e.svg";